export const messages = {
    "wr-dashboard.search.input.hint": "検索",
    "wr-dashboard.search.label.breadcrumb": "検索結果",
    "wr-dashboard.search.message.empty": "検索に一致する項目はありません",
    "wr-dashboard.side-bar.selected.title:plural": "{count}アイテム選択済み | {count}アイテム選択済み",
    "wr-dashboard.side-bar.backup-type.disk": "ディスク",
    "wr-dashboard.side-bar.backup-type.file": "ファイル",
    "wr-dashboard.side-bar.backup-type.notarized": "公証済みのファイルとフォルダ",
    "wr-dashboard.side-bar.backup-type.exchange": "アプリケーション - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "アプリケーション - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "アプリケーション - システム状態",
    "wr-dashboard.side-bar.backup-type.application": "アプリケーション",
    "wr-dashboard.backups-table.column.name": "名前",
    "wr-dashboard.backups-table.column.size": "サイズ",
    "wr-dashboard.backups-table.column.version": "最新バージョン",
    "wr-dashboard.backups-table.action.delete": "削除",
    "wr-dashboard.backups-table.message.no-backups": "クラウドにはまだバックアップがありません",
    "wr-dashboard.backups-sidebar.label.size": "サイズ",
    "wr-dashboard.backups-sidebar.label.type": "タイプ",
    "wr-dashboard.backups-sidebar.label.version": "最新バージョン",
    "wr-dashboard.backups-sidebar.label.created": "作成",
    "wr-dashboard.backups-sidebar.label.machine": "マシン",
    "wr-dashboard.backups-sidebar.label.owner": "所有者",
    "wr-dashboard.content-table.column.name": "名前",
    "wr-dashboard.content-table.column.versions": "バージョン",
    "wr-dashboard.content-table.column.volumes": "ボリューム",
    "wr-dashboard.content-table.column.path": "パス",
    "wr-dashboard.content-table.column.size": "サイズ",
    "wr-dashboard.content-table.column.version": "最新バージョン",
    "wr-dashboard.content-table.action.notary-verify": "ベリファイ",
    "wr-dashboard.content-table.action.notary-get-crt": "証明書の取得",
    "wr-dashboard.content-table.action.asign": "署名のために送信",
    "wr-dashboard.content-table.action.versions": "バージョン",
    "wr-dashboard.content-table.action.restore": "ダウンロード",
    "wr-dashboard.content-table.label.size": "サイズ",
    "wr-dashboard.content-table.label.created": "作成",
    "wr-dashboard.content-table.label.modified": "変更日",
    "wr-dashboard.content-table.message.empty-folder": "このフォルダは空です",
    "wr-dashboard.password-dialog-box.title.backup": "暗号化されたバックアップ",
    "wr-dashboard.password-dialog-box.title.archive": "暗号化されたアーカイブ",
    "wr-dashboard.password-dialog-box.message.backup": "バックアップ{displayName}にアクセスするためのパスワードを指定してください",
    "wr-dashboard.password-dialog-box.message.archive": "アーカイブ{displayName}にアクセスするためのパスワードを指定してください",
    "wr-dashboard.password-dialog-box.hint.password": "パスワード",
    "wr-dashboard.password-dialog-box.message.invalid-password": "パスワードが正しくありません",
    "wr-dashboard.form.button.open": "開く",
    "wr-dashboard.form.button.close": "閉じる",
    "wr-dashboard.form.button.cancel": "キャンセル",
    "wr-dashboard.form.button.continue": "続行",
    "wr-dashboard.form.button.proceed": "続行",
    "wr-dashboard.form.button.delete": "削除",
    "wr-dashboard.form.button.done": "完了",
    "wr-dashboard.form.button.retry": "再試行",
    "wr-dashboard.notary.verify.view.status.downloading": "ダウンロードしています...",
    "wr-dashboard.notary.verify.view.status.validating": "ベリファイしています...",
    "wr-dashboard.notary.verify.view.status.pending": "証明書を保留にしています...",
    "wr-dashboard.notary.verify.view.status.fail": "証明書の不一致...",
    "wr-dashboard.notary.verify.view.button.get-crt": "証明書の取得",
    "wr-dashboard.notary.verify.view.file-info.name": "名前",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "署名者",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "日付をバックアップ済み",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "日付を公証済み",
    "wr-dashboard.notary.verify.view.button.cancel": "キャンセル",
    "wr-dashboard.notary.verify.view.button.done": "完了",
    "wr-dashboard.notary.warning.unsupported.browser.version": "サポートされていないブラウザのバージョン",
    "wr-dashboard.versions-dialog-box.title": "{fileName}のバージョン",
    "wr-dashboard.asign-dialog-box.title": "署名のために送信",
    "wr-dashboard.asign-dialog-box.message": "ファイルのバージョンは共有されていますが、そのバージョンへのリンクがなければファイルを表示できません。ASignに進み、署名を追加し、リンクを共有します。",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "ファイルの詳細情報の表示",
    "wr-dashboard.page-not-found.title": "ページが見つかりません",
    "wr-dashboard.page-not-found.message.main": "お探しのページが見つかりませんでした。",
    "wr-dashboard.page-not-found.message.description": "リンクが古いか、アドレスが正しく入力されなかった可能性があります。",
    "wr-dashboard.page-not-found.message.error": "エラー コード:404",
    "wr-dashboard.server-error.title": "サーバーを利用できません",
    "wr-dashboard.server-error.message": "サーバーは現在使用できません。後でもう一度お試しください。",
    "wr-dashboard.server-error.message.error": "エラー コード:500",
    "wr-dashboard.account-menu.action.sign-out": "サインアウト",
    "wr-dashboard.breadcrumb.item.machines": "マシン",
    "wr-dashboard.breadcrumb.item.failed-backups": "バックアップに失敗しました",
    "wr-dashboard.machines-table.column.name": "名前",
    "wr-dashboard.machines-table.column.size": "サイズ",
    "wr-dashboard.machines-table.message.no-machines": "クラウドにはまだマシンがありません",
    "wr-dashboard.incomplete-backups.message.status:plural": "失敗したまたは不完全なバックアップが{count}個あり、ストレージの{size} を占めています | 失敗したまたは不完全なバックアップが{count}個あり、ストレージの{size} を占めています",
    "wr-dashboard.incomplete-backups.button.view": "バックアップを表示する",
    "wr-dashboard.incomplete-backups.button.delete": "バックアップを削除する",
    "wr-dashboard.machines-table.message.space-used:plural": "合計バックアップ使用状況 {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "アーカイブの削除",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "不完全なアーカイブを削除する",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "すべての不完全なアーカイブを削除する",
    "wr-dashboard.delete-archive.message": "選択したアーカイブをすべてのロケーションから完全に削除してもよろしいですか。すべてのデータは削除されて復元できなくなります。",
    "wr-dashboard.delete-archive.deletion-warning-message": "このWeb復元コンソールで行う変更は、該当のワークロードがオンラインでない場合、または変更を処理するエージェントがオンラインでない場合、保護コンソールの該当ワークロードに視覚的に反映されない可能性があります",
    "wr-dashboard.delete-archive.locked-error-message": "データの一貫性を確保するため、アーカイブがロックされました。アーカイブを伴うすべての操作（ブラウズ、復元、バックアップなど）を終了して再試行してください。",
    "wr-dashboard.certificate-pending-dialog-box.title": "証明書の保留中",
    "wr-dashboard.certificate-pending-dialog-box.message": "数分後にもう一度お試しください。",
    "wr-dashboard.form.button.ok": "OK"
};
